// extracted by mini-css-extract-plugin
export default {"container":"Wl-z","bubbleNav":"Xl-z","graphic":"Yl-z","contact":"Zl-z"};